<template>
  <div class="invoice-apply">
    <custom-tab v-model="tab" :list="tabList" @change="onTab" style="margin: -24px 0 24px -24px; width: calc(100% + 48px)"></custom-tab>
    <!-- 待开票账单信息 -->
    <div v-if="tab === '1'">
      <custom-table
        v-show="tab === '1'"
        :key="1"
        index
        :data="tableList"
        tableCode="invoiceApply"
        @sort="sortChange"
        @filter="filterChange"
        :slots="['termNum', 'isPreInvoice', 'isRedInvoice', 'taxRate', 'itemCode', 'itemName', 'invoiceType', 'itemUnit', 'invoiceAmount', 'action']"
      >
        <template slot="termNum" slot-scope="scope">{{ scope.row.termNum || '-' }}/{{ scope.row.totalTerm || '-' }}</template>
        <template slot="invoiceType" slot-scope="scope">
          <invoice-type-select
            @change="updateTypeAndClassByValue(scope.row, $event)"
            @init="initTypeAndClassByValue(scope.row, $event)"
            :value="[scope.row.invoiceType, scope.row.invoiceClass]"
            :disabled="model.type === 'watch'"
            :placeholder="scope.$index ? $t('components_invoice_apply.tong_shang') : null"
            width="150px"
          ></invoice-type-select>
        </template>
        <template slot="isPreInvoice" slot-scope="scope">
          {{ getDicValue('is_pre_invoice', scope.row.billTradeState != '2') }}
        </template>
        <template slot="isRedInvoice">
          {{ getDicValue('is_red_invoice', 'false') }}
        </template>
        <template slot="taxRate" slot-scope="scope">
          <el-input type="number" :disabled="model.type === 'watch'" v-model="scope.row.taxRate" :placeholder="scope.$index ? $t('components_invoice_apply.tong_shang') : ''" style="width: 60px"></el-input>
        </template>
        <template slot="itemCode" slot-scope="scope">
          <el-input :disabled="model.type === 'watch'" v-model="scope.row.itemCode" :placeholder="scope.$index ? $t('components_invoice_apply.tong_shang') : ''" style="width: 120px"></el-input>
        </template>
        <template slot="itemName" slot-scope="scope">
          <el-input :disabled="model.type === 'watch'" v-model="scope.row.itemName" :placeholder="scope.$index ? $t('components_invoice_apply.tong_shang') : ''" style="width: 120px"></el-input>
        </template>
        <template slot="itemUnit" slot-scope="scope">
          <el-input :disabled="model.type === 'watch'" v-model="scope.row.itemUnit" :placeholder="scope.$index ? $t('components_invoice_apply.tong_shang') : ''" style="width: 60px"></el-input>
        </template>
        <template slot="invoiceAmount" slot-scope="scope">
          <span v-if="model.type === 'watch'">
            <!-- 审批中心查看直接取invoiceAmount -->
            {{ scope.row.isRedInvoice ? '-' : '' }} {{ scope.row.invoiceAmount || 0 }}
          </span>
          <span v-else>
            <!-- 未审批需计算 -->
            {{ scope.row.isRedInvoice ? '-' : '' }} {{ scope.row.paymentAmount - (scope.row.invoiceAmount || 0) }}
          </span>
        </template>
        <template slot="action" slot-scope="scope">
          <el-button v-if="`${scope.row.billType}` !== '19'" :disabled="model.type === 'watch'" type="text" size="mini" @click="onDeleteRow(scope.$index)">{{ $t('Common.com_delete') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div v-if="tab === '2'">
      <custom-table-expand
        v-show="tab === '2'"
        :key="2"
        ref="customTb1"
        :rowId="getRowKeys"
        :data="invoiceList"
        :expandsList="expandsList"
        tableCode="invoiceEstimatedInfo"
        @sort="sortChange"
        @filter="filterChange"
        expand-row-keys
        expand
        :slots="['expand', 'invoiceAmount', 'invoiceType', 'action']"
      >
        <template slot="expand" slot-scope="scope">
          <div class="record-detail" v-if="scope.row">
            <div class="item-title">{{ $t('components_invoice_apply.fa_piao_xin_xi') }}</div>
            <invoice-ticket :data="scope.row" :type="scope.row.isRedInvoice"></invoice-ticket>
            <div class="item-title">{{ $t('components_invoice_apply.fa_piao_ming_xi') }}</div>
            <invoice-billList v-if="scope.row.invoiceBillList" :type="scope.row.isRedInvoice" :data="scope.row.invoiceBillList" :isApply="model.type !== 'watch'"></invoice-billList>
          </div>
        </template>
        <template slot="invoiceType" slot-scope="scope">{{ getItemNameByTypeAndClass(scope.row.invoiceType, scope.row.invoiceClass) }}</template>
        <template slot="invoiceAmount" slot-scope="scope">{{ scope.row.isRedInvoice ? '-' : '' }} {{ scope.row.invoiceAmount || '-' }}</template>
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" @click="onRowExpansion(scope.row)">{{ $t('components_invoice_apply.cha_kan_fa_piao') }}</el-button>
        </template>
      </custom-table-expand>
    </div>
    <el-form style="margin-top: 24px" :model="form" ref="form" label-width="auto" :rules="rules">
      <el-form-item :label="$t('components_invoice_apply.shen_qing_miao_shu')" prop="desc">
        <el-input type="textarea" :disabled="model.type === 'watch'" :rows="4" placeholder="" v-model="form.desc" style="width: 800px"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import languageInjectMixins from '@/mixins/language_inject_mixins.js';
import customTableExpand from '@/components/customTableExpand.vue';
import invoiceTicket from '@/pages/fms/components/invoice_ticket.vue';
import invoiceBillList from '@/pages/fms/components/invoice_billList.vue';
import invoiceTypeSelect from '@/components/invoiceTypeSelect.vue';
import invoiceTypeMixins from '@/mixins/invoice_type_mixins.js';

export default {
  mixins: [languageInjectMixins, invoiceTypeMixins],
  components: { invoiceTicket, invoiceBillList, customTableExpand, invoiceTypeSelect },
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '',
        };
      },
    },
  },
  computed: {
    rules() {
      return {
        desc: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
        ],
      };
    },
    tabList() {
      return [
        {
          name: this.$t('components_invoice_apply.dkpzdxx'),
          value: '1',
        },
        {
          name: this.$t('components_invoice_apply.yu_ji_fa_piao_xin_xi'),
          value: '2',
        },
      ];
    },
  },
  data() {
    return {
      tab: '1',
      tableList: [],
      form: {
        changeId: '',
        billList: [],
        desc: '',
      },
      // 发票列表
      invoiceList: [],
      expandsList: [],
      // 获取row的key值
      getRowKeys(row) {
        return row.invoiceId;
      },
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    initDialog: function () {
      if (this.model.type === 'add') {
        this.tableList = JSON.parse(JSON.stringify(this.model.row));
      }
      if (this.model.type === 'edit' || this.model.type === 'watch') {
        this.form.changeId = this.model.changeId;
        this.getChangeDetail();
      }
    },
    // 获取编辑查看详情
    getChangeDetail: function () {
      this.$getJSON(`${apis.invoiceEditDetail}/${this.form.changeId}`).then((res) => {
        // originalAmount用来暂存总开票金额
        let list = res.data.invoiceBillList;
        list = list.map((t) => (t.invoiceBillList ? t.invoiceBillList.map((f) => Object.assign({}, t, f, { originalAmount: t.invoiceAmount })) : []));
        list = list.reduce((pre, item) => [...pre, ...item], []);
        list = list.filter((t) => !t.isRedInvoice);
        this.tableList = list;
        this.form.desc = res.data.changeBo.changeDesc;
      });
    },
    // 确认保存
    onConfirm: function (approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.form.goSubmit = !!approve; // 草稿、提交
        const billList = this.$formatCopyUp(this.tableList, ['invoiceType', 'itemName', 'taxRate', 'itemUnit']);
        const hasEmpty = billList.find((t) => !t.invoiceType || !t.itemName || !t.taxRate);
        if (hasEmpty) {
          this.$message.error(this.$t('components_invoice_apply.qjsjtxwz'));
          return;
        }
        this.form.billList = billList.map((t) => ({
          billId: t.billId,
          // thisInvoiceAmount: t.paymentAmount - (t.invoiceAmount || 0) + (t.overdueAmount || 0) + (t.breakAmount || 0),
          thisInvoiceAmount: t.paymentAmount - (t.invoiceAmount || 0),
          isRedInvoice: false,
          invoiceType: t.invoiceType,
          invoiceClass: t.invoiceClass,
          itemName: t.itemName,
          taxRate: t.taxRate,
          itemUnit: t.itemUnit,
          // 发票类别 1-纸质发票，2-电子发票
          // 暂时写死
          // invoiceClass: 1
        }));
        this.$postJSON(apis.invoiceSubmit, this.form).then((res) => {
          if (approve) {
            this.onSubmit(res.data);
            return;
          }
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success', this.form);
        });
      });
    },
    onSubmit(row) {
      this.$postJSON(
        `${apis.apsApproveApprovalApproveStart}/invoice/${row.changeId}`,
        {
          title: [`【${row.changeId}】`, this.getDicValue('approval_type', 'invoice')].join(' '),
          applyReason: row.changeDesc,
        },
        true
      ).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.$emit('success', this.form);
      });
    },
    // 删除行
    onDeleteRow: function (index) {
      const nextList = this.tableList.slice(index + 1);
      const hasBillType19 = nextList.some((t) => `${t.billType}` === '19');
      const isNextAllBillType19 = hasBillType19 && nextList.every((t) => `${t.billType}` === '19');
      // 如果当前删除行往下都是billType为19的数据，则一并删除这些billType为19的数据
      this.tableList.splice(index, isNextAllBillType19 ? nextList.length + 1 : 1);
    },
    // 发票列表
    onTab: function (num) {
      if (num === '2') {
        // 审批时已经申请开票了 直接用发票详情就可以了
        if (this.model.type === 'watch') {
          const obj = {};
          const list = [];
          const arr = [...this.tableList];
          arr.forEach((item) => {
            // originalAmount是原本的总开票金额
            item.invoiceAmount = item.originalAmount;
            if (!obj[item.invoiceCode] && !item.isRedInvoice) {
              list.push(item);
            }
            obj[item.invoiceCode] = true;
          });
          this.invoiceList = list;
        } else {
          this.getInvoiceList();
        }
      }
    },
    getInvoiceList: function () {
      const miargeList = this.tableList.map((t) => ({
        billId: t.billId,
        isRedInvoice: false,
        invoiceType: t.invoiceType,
        invoiceClass: t.invoiceClass,
        itemName: t.itemName,
        taxRate: t.taxRate,
        itemUnit: t.itemUnit,
        // thisInvoiceAmount: t.paymentAmount - (t.invoiceAmount || 0) + (t.overdueAmount || 0) + (t.breakAmount || 0)
        thisInvoiceAmount: t.paymentAmount - (t.invoiceAmount || 0),
      }));
      this.$postJSON(apis.invoiceMargeBill, miargeList).then((res) => {
        this.invoiceList = res.data || [];
      });
    },
    onRowExpansion: function (row) {
      this.$refs.customTb1.$emit('toggleRowExpansion', row, true);
    },
  },
};
</script>

<style lang="scss">
.invoice-apply {
  .el-table__expanded-cell {
    padding: 0;
  }
  .record-detail {
    padding: 20px 0;
  }
}
</style>
